/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading for the BizCharts component
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import loadable from '@loadable/component';

export default loadable.lib(() => import(/* webpackChunkName: "BizCharts" */ 'bizcharts'));
